import { render, staticRenderFns } from "./AccountModalBase.vue?vue&type=template&id=848194b0&scoped=true&"
import script from "./AccountModalBase.vue?vue&type=script&lang=ts&"
export * from "./AccountModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./AccountModalBase.vue?vue&type=style&index=0&id=848194b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848194b0",
  null
  
)

export default component.exports